import { callAPI, HTTPMethod } from './API'
import {
    Users,
    UserListParams,
    UserRequest,
    User,
    UserMetadataResponse,
} from '../model'

export async function listTenantUsers(
    tenantId: string,
    params: UserListParams
): Promise<Users> {
    return await callAPI(`/tenants/${tenantId}/users`, {
        method: HTTPMethod.GET,
        query: {
            search: params.search ?? '',
            pageSize: `${params.page ?? 20}`,
            offset: `${params.offset ?? 0}`,
            roleId: params.roleId ?? '',
        },
    })
}

export async function getTenantUsersMetadata(
    tenantId: string
): Promise<UserMetadataResponse> {
    return await callAPI(`/tenants/${tenantId}/users/metadata`, {
        method: HTTPMethod.GET,
    })
}

export async function createTenantUser(
    tenantId: string,
    request: UserRequest
): Promise<User> {
    return await callAPI(`/tenants/${tenantId}/users`, {
        method: HTTPMethod.POST,
        body: request,
    })
}

export async function getTenantUser(
    tenantId: string,
    userId: string,
    includeMetadata?: boolean
): Promise<User> {
    return await callAPI(`/tenants/${tenantId}/users/${userId}`, {
        method: HTTPMethod.GET,
        query: {
            include_metadata: `${!!includeMetadata}`,
        },
    })
}

export async function updateTenantUser(
    tenantId: string,
    userId: string,
    request: UserRequest
): Promise<User> {
    return await callAPI(`/tenants/${tenantId}/users/${userId}`, {
        method: HTTPMethod.PUT,
        body: request,
    })
}

export async function deleteTenantUser(
    tenantId: string,
    userId: string
): Promise<void> {
    return await callAPI(`/tenants/${tenantId}/users/${userId}`, {
        method: HTTPMethod.DELETE,
    })
}

export async function blockTenantUser(
    tenantId: string,
    userId: string
): Promise<void> {
    return await callAPI(`/tenants/${tenantId}/users/${userId}/block`, {
        method: HTTPMethod.PUT,
    })
}

export async function unblockTenantUser(
    tenantId: string,
    userId: string
): Promise<void> {
    return await callAPI(`/tenants/${tenantId}/users/${userId}/block`, {
        method: HTTPMethod.DELETE,
    })
}
